import { useState, useCallback } from 'react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function parseErrorDetail(err, fallback) {
  const detail = err.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e.msg || JSON.stringify(e)).join(', ');
  return fallback;
}

export function useNewsletterForm() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = useCallback(async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success(data.message);
      setEmail('');
    } catch (err) {
      toast.error(parseErrorDetail(err, 'Subscription failed'));
    } finally {
      setLoading(false);
    }
  }, [email]);

  return { email, setEmail, loading, submit };
}

const EMPTY_CONTACT = { name: '', email: '', subject: '', message: '' };

export function useContactForm() {
  const [form, setForm] = useState(EMPTY_CONTACT);
  const [loading, setLoading] = useState(false);

  const setField = useCallback((key, value) => {
    setForm(prev => ({ ...prev, [key]: value }));
  }, []);

  const submit = useCallback(async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Please fill in all required fields');
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/contact`, form);
      toast.success(data.message);
      setForm(EMPTY_CONTACT);
    } catch (err) {
      toast.error(parseErrorDetail(err, 'Failed to send message'));
    } finally {
      setLoading(false);
    }
  }, [form]);

  return { form, setField, loading, submit };
}
